// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useLocalSearchParams } from 'expo-router';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/Themed';
import appColors from '@/theme/colors';
import TourEditLayout from '@/features/tour-edit/components/TourEditLayout';

export default function TourEditScreen() {
  const { tourId } = useLocalSearchParams<{ tourId?: string }>();

  if (!tourId) {
    return (
      <View style={styles.errorContainer}>
        <Text style={styles.errorText}>Tour not found</Text>
      </View>
    );
  }

  return <TourEditLayout tourId={tourId} />;
}

const styles = StyleSheet.create({
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: appColors.background.app,
  },
  errorText: {
    fontSize: 16,
    color: appColors.status.danger,
    fontWeight: '600',
  },
});
